import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import type { UploadSuppressionListPayload } from "../../components/types";
import { SuppressionListActions } from "../../store/action-creators";

export const sendParsedList =
    (payload: UploadSuppressionListPayload) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(SuppressionListActions.sendParsedAsync.request());

        try {
            const response = await deps.si.api.management.postSuppressionList(payload);
            return dispatch(SuppressionListActions.sendParsedAsync.success(response));
        } catch (error) {
            return dispatch(SuppressionListActions.sendParsedAsync.failure(error));
        }
    };

export const deleteSuppressionListAsync =
    () => async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(SuppressionListActions.deleteListAsync.request());

            await deps.si.api.management.deleteSuppressionList();

            dispatch(SuppressionListActions.deleteListAsync.success());
        } catch (error) {
            dispatch(SuppressionListActions.deleteListAsync.failure(error));
        }
    };

export const fetchSuppressionListsThunk =
    () => async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(SuppressionListActions.fetchSuppressionListsAsync.request());

        try {
            const lists = await deps.si.api.management.fetchSuppressionLists();
            return dispatch(SuppressionListActions.fetchSuppressionListsAsync.success(lists));
        } catch (error) {
            return dispatch(SuppressionListActions.fetchSuppressionListsAsync.failure(error));
        }
    };
